// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-Efy4B8","tooltipIcon":"tooltipIcon-Ae9I4o","syncPrint":"syncPrint-NdJ9qi"};